module.exports = __webpack_public_path__ + "img/coin.9663d858.png";